import api from "../api/axios";

/*
|--------------------------------------------------------------------------
| LISTAR BANNERS
|--------------------------------------------------------------------------
*/

export const obtenerBannersComunidad = async () => {

    const response = await api.get(
        "/getBannercomunidad"
    );

    return response.data.data;
};


/*
|--------------------------------------------------------------------------
| OBTENER BANNER POR ID
|--------------------------------------------------------------------------
*/

export const obtenerBannerComunidad = async (id) => {

    const response = await api.get(
        `/showBannerComunidad/${id}`
    );

    return response.data.data;
};


/*
|--------------------------------------------------------------------------
| CREAR BANNER
|--------------------------------------------------------------------------
*/

export const crearBannerComunidad = async (formData) => {

    const response = await api.post(
        "/crear/banner/comunidad",
        formData,
        {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }
    );

    return response.data;
};


/*
|--------------------------------------------------------------------------
| EDITAR BANNER
|--------------------------------------------------------------------------
*/

export const editarBannerComunidad = async (
    id,
    formData
) => {

    const response = await api.post(
        `/editar/banner/comunidad/${id}`,
        formData,
        {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }
    );

    return response.data;
};


/*
|--------------------------------------------------------------------------
| ELIMINAR BANNER
|--------------------------------------------------------------------------
*/

export const eliminarBannerComunidad = async (id) => {

    const response = await api.delete(
        `/eliminar/banner/comunidad/${id}`
    );

    return response.data;
};


export const getBannerComunidadPublic = async () => {
    try {
        const response = await api.get("/get/public/Bannercomunidad");

        return response.data.data;
         
    } catch (error) {
        console.error(
            "Error al obtener el banner público de comunidad:",
            error
        );

        throw error;
    }
};